import React, { useState, useEffect } from 'react';
import { Collapse, List, ListItem } from '@material-ui/core';

import { mainRoutes } from '../../routes';
import { useHistory } from 'react-router-dom';

import { ListIcon, ListText, LogoutItem, StyledDrawer, StyledList, StyledListItem, SubListItem, SubMenuIcon } from './style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faChevronDown, faChevronUp, faSearch, faUser, faSignOutAlt, faUserFriends, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { userLogout } from '../../actions/Auth';

const SideMenu = ({ open, onMouseEnter, onMouseLeave }) => {

  const { hasLog } = useSelector(({ auth }) => ({
    hasLog: auth?.userData?.userLogado?.has_log || undefined
  }));

  useEffect(() => {
    verificarHistorico(hasLog)

  }, []);

  const history = useHistory();
  const [subOpen, setSubOpen] = useState(false);

  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(userLogout()).then(history.push('/Login'));
  };

  const verificarHistorico = (hasLog) => {
    if (!hasLog) {
      handleLogout()
    }
  }


  const { isAdm, userData, email } = useSelector(({ auth }) => ({
    isAdm: auth?.userData?.isAdm || false,
    email: auth?.userData?.email || '',
    userData: auth?.users || [],
  }));

  const commonRoutes = isAdm ? mainRoutes : mainRoutes.filter((f) => !f.isAdm);
  return (
    <StyledDrawer
      onMouseEnter={() => onMouseEnter()}
      onMouseLeave={() => {
        onMouseLeave();
        setSubOpen(false);
      }}
      anchor="left"
      open={open}
      variant="permanent"
    >
      <StyledList>
        {commonRoutes.map((item, index) => {
          let selected = window?.location?.pathname?.toUpperCase() === item?.path?.toUpperCase();
          return (
            item.icon &&
            item.label &&
            !item.isAdm && (
              <div key={index}>
                <StyledListItem selected={selected} button onClick={() => (item.subMenu ? setSubOpen(!subOpen) : history.push(item.path))}>
                  <ListIcon selected={selected}>
                    <FontAwesomeIcon icon={item.icon} />
                  </ListIcon>
                  <ListText open={open} selected={selected} primary={item.label} />
                  {item.subMenu && <SubMenuIcon icon={subOpen ? faChevronUp : faChevronDown} />}
                </StyledListItem>
              </div>
            )
          );
        })}

        <StyledListItem button onClick={() => window.open('https://se.manserv.com.br/softexpert/workspace?page=dashboard,2c8a80027ee1cd3d0180c0705e0575e0,2c8a8002813acccc0181d8e5a3437222', '_blank')}>
          <ListIcon>
            <FontAwesomeIcon icon={faBook} />
          </ListIcon>
          <ListText primary="Documentos" />
        </StyledListItem>
        <StyledListItem button onClick={() => window.open('https://fa-euld-saasfaprod1.fa.ocs.oraclecloud.com/fscmUI/redwood/learner/learn/learn-landing?tab=myLearnExperience', '_blank')}>
          <ListIcon>
            <FontAwesomeIcon icon={faGraduationCap} />
          </ListIcon>
          <ListText primary="Aprendizagem" />
        </StyledListItem>
      </StyledList>
      <List>

        {commonRoutes.map((item, index) => {
          let selected = window?.location?.pathname?.toUpperCase() === item?.path?.toUpperCase();
          return (
            item.icon &&
            item.label &&
            item.show && (
              <div key={index}>
                <StyledListItem selected={selected} button onClick={() => (item.subMenu ? setSubOpen(!subOpen) : history.push(item.path))}>
                  <ListIcon selected={selected}>
                    <FontAwesomeIcon icon={item.icon} />
                  </ListIcon>
                  <ListText open={open} selected={selected} primary={item.label} />
                  {item.subMenu && <SubMenuIcon icon={subOpen ? faChevronUp : faChevronDown} />}
                </StyledListItem>
              </div>
            )
          );
        })}

        <StyledListItem button onClick={() => handleLogout()}>
          <ListIcon>
            <FontAwesomeIcon icon={faSignOutAlt} />
          </ListIcon>
          <ListText primary="Sair" />
        </StyledListItem>
      </List>
    </StyledDrawer>
  );
};

export default SideMenu;
